module.exports = __webpack_public_path__ + "static/media/wall-music-background-gradient.ca9743b6.png";